module.exports = __webpack_public_path__ + "img/contents_taxi@2x.95cb5dd1.png";